/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Where a composite data cut row came from, stamped when the row is written. manualSeed: a placeholder from the Start manually strategy — nothing picked yet, which is what surfaces as the needSelection row status. reusedFromPrior: carried over from the previous edition by the reuse pass. defaultedFromPolicy: derived by a cut-selection policy run, including a named pricing policy. manuallyPicked: the user toggled the cut on Cut Review.
 */
export enum SurveyReplacementCompositeDataCutSelectionSource {
    MANUAL_SEED = 'manualSeed',
    REUSED_FROM_PRIOR = 'reusedFromPrior',
    DEFAULTED_FROM_POLICY = 'defaultedFromPolicy',
    MANUALLY_PICKED = 'manuallyPicked',
}
